import { ExternalLink, Link, Video, ArrowLeft } from "lucide-react";
import PageWrapper from "../page-wrapper/page-wrapper.components";
import toast from "react-hot-toast";

const MarketingVideo = {
    "claimsnaphowto": "https://player.vimeo.com/video/1148762084?h=45ba8e44bf",
    "choosenhc": "https://player.vimeo.com/video/564787706?h=81e49d1ba9",
    "businessowners": "https://player.vimeo.com/video/625716101",
    "detachhsa": "https://player.vimeo.com/video/667511212?h=cf2b662893",
    "flexdemo": "https://player.vimeo.com/video/1052057750",
    "enhancedbenefits": "https://player.vimeo.com/video/1059081541",
    "onlineenrollments": "https://player.vimeo.com/video/1064429414"
};

const VideoPage = ({ videoType, title }) => {
    const copyToClipboard = () => {
        const videoSrc = MarketingVideo[videoType];
        navigator.clipboard.writeText(videoSrc).then(() => {
            toast.success("Link copied to clipboard!");
        });
    };

    return (
        <PageWrapper>
            <div className="flex-1 px-6 md:px-12 lg:pl-12 lg:pr-24 py-6 pb-5 overflow-y-auto">
                {/* back link */}
                <a
                    href="/user/videos"
                    className="inline-flex items-center gap-2 text-sm text-gray-500 hover:text-primary transition-colors mb-6"
                >
                    <ArrowLeft className="w-4 h-4" />
                    Back to Videos
                </a>

                {/* page header with icon */}
                <div className="flex items-center gap-3 mb-6">
                    <div className="p-2 bg-primary/10 rounded-xl">
                        <Video className="w-6 h-6 text-primary" />
                    </div>
                    <div>
                        <h1 className="text-2xl md:text-3xl font-bold text-gray-900">
                            {title}
                        </h1>
                        <p className="text-sm text-gray-500">
                            Marketing video
                        </p>
                    </div>
                </div>

                {/* video card */}
                <div className="bg-white rounded-2xl shadow-card overflow-hidden max-w-4xl">
                    <div className="aspect-video w-full">
                        <iframe
                            title={videoType}
                            src={MarketingVideo[videoType]}
                            className="w-full h-full"
                            allow="autoplay; fullscreen; picture-in-picture"
                        />
                    </div>
                    <div className="p-4 border-t border-gray-100 flex gap-3">
                        <button
                            className="flex items-center gap-2 bg-primary text-white py-2.5 px-5 rounded-xl font-semibold hover:bg-primary-dark active:scale-[0.98] transition-all duration-200"
                            onClick={() => window.open(MarketingVideo[videoType], '_blank', 'noopener,noreferrer')}
                        >
                            Open Video
                            <ExternalLink className="w-4 h-4" />
                        </button>
                        <button
                            className="flex items-center gap-2 bg-gray-50 text-gray-700 py-2.5 px-5 border border-gray-200 rounded-xl font-semibold hover:bg-gray-100 active:scale-[0.98] transition-all duration-200"
                            onClick={copyToClipboard}
                        >
                            <Link className="w-4 h-4" />
                            Copy Link
                        </button>
                    </div>
                </div>
            </div>
        </PageWrapper>
    );
};

export default VideoPage;
